export const CREATE_IR_TEMPLATE = 'CREATE_IR_TEMPLATE'

export const UPDATE_IR_TEMPLATE = 'UPDATE_IR_TEMPLATE'
